var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-slide-trait view-slide",class:'direction-' + _vm.direction},[_c('figure',[_c('ViewTraitGrid')],1),_c('div',{staticClass:"content"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.body)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }